import { Stroke, Style, RegularShape } from 'ol/style';
import { POINT, POLYGON } from 'client/utils/constants/geometryType';
import { Feature } from 'ol';

export const mobileAOIStyle = (feature) => {
    if (!feature || !(feature instanceof Feature)) {
        return new Error('style: invalid feature type');
    }
    const geometry = feature.getGeometry();
    if (!geometry) {
        return new Error('style: feature has no geometry');
    }
    const featureType = geometry.getType();
    if (featureType === POLYGON) { // Style for the square
        return new Style({
            stroke: new Stroke({
                color: 'black',
                width: 2
            })
        });
    } else if (featureType === POINT) { // Style for the crosshair (plus symbol)
        return new Style({
            image: new RegularShape({
                points: 4,
                radius: 10,
                radius2: 0,
                angle: 0,
                stroke: new Stroke({
                    color: 'black',
                    width: 2
                })
            })
        });
    }
};

export default mobileAOIStyle;
